import styled from "styled-components";
import React from "react";
import { COLORS } from "../contants/colors";
import { QUERIES } from "../contants/allConstants";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";

const EditButton = ({ onClick }) => {
  return (
    <Button onClick={onClick}>
      <Box
        component={Icon}
        icon={"eva:edit-2-outline"}
        // boxSizing={30}
        width={20}
        height={18}
      />
    </Button>
  );
};
const Button = styled.button`
  border-radius: 6px;
  background-color: ${COLORS.lightBlue};
  border: none;
  height: 36px;
  width: 60px;
  color: ${COLORS.primary};
  &:focus {
    outline-color: ${COLORS.primary};
  }
  @media (${QUERIES.mobileAndDown}) {
    width: 100%;
  }
`;

// const Icon = styled.img`
//   width: 15px;
//   height: 18px;
//   object-fit: fill;
//   cursor: pointer;
// `;

export default EditButton;
